import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  commentPaper: {
    marginBottom: 20,
    minHeight: 96,
    padding: 0,
    "&:last-child": {
      marginBottom: 24,
      [theme.breakpoints.down("xs")]: {
        marginBottom: 16
      }
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 16
    }
  },
  addCommentPaper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  active: {
    "&&.MuiPaper-root > div": {
      display: "block",
      opacity: 1
    }
  },
  hidden: {
    display: "none"
  },
  clickable: {
    cursor: "pointer"
  },
  addCommentPaperIcon: {
    color: theme.palette.text.secondary,
    fontSize: 28
  },
  addCommentPaperText: {
    color: theme.palette.text.secondary
  },
  commentHeader: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20
  },
  authorDateContainer: {},
  author: {
    fontSize: 16
  },
  commentDate: {
    opacity: "0.8"
  },
  commentText: {
    lineHeight: "normal",
    fontSize: 14,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 0,
    paddingBottom: 24,
    wordBreak: "break-word"
  },
  commentActions: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    textAlign: "right"
  },
  commentButton: {
    display: "flex",
    alignItems: "center",
    height: 24,
    paddingTop: 4,
    paddingBottom: 4,
    marginLeft: 10,
    borderRadius: 2,
    borderColor: theme.palette.primary.light,
    paddingLeft: 12,
    paddingRight: 12,
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      padding: 0,
      minWidth: 24,
      "& .MuiButton-label": {
        width: 24
      }
    }
  },
  commentButtonText: {
    fontSize: 12,
    lineHeight: "normal",
    color: theme.palette.primary.dark,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  commentButtonIcon: {
    fontSize: 14,
    color: theme.palette.primary.dark
  }
}));
